module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('app-loading') : _c('div', [_c('div', {
    staticClass: "grid grid-cols-12 gap-6 mt-5"
  }, [_c('div', {
    staticClass: "intro-y col-span-12 lg:col-span-12"
  }, [_c('div', {
    staticClass: "intro-y box"
  }, [_c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("\n              Editar Tarea (Admin) - "), _c('app-title-custom')], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check w-full sm:w-auto sm:ml-auto mt-3 sm:mt-0"
  }, [_vm._v("\n              Creada por:"), _c('label', {
    staticClass: "form-check-label ml-0 sm:ml-2",
    attrs: {
      "for": "show-example-1"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.task.user_created_name) + " - " + _vm._s(_vm.task.created_at) + "\n              ")])])]), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5 form-task",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updateTask.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6 xxl:col-span-12"
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.task.name
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('name', $event)
      }
    }
  })]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Fecha de entrega")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": _vm.task.date
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('date', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-6 sm:col-span-6 xxl:col-span-12"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": _vm.task.description
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('description', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Horas")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "step": ".01"
    },
    domProps: {
      "value": _vm.task.hours
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('hours', $event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Proyecto")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "v-model": _vm.aux_task.project_id,
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('project_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione...")]), _vm._v(" "), _vm._l((_vm.projects), function(project) {
    return _c('option', {
      domProps: {
        "value": project.id
      }
    }, [_vm._v("\n                  " + _vm._s(project.name) + " - " + _vm._s(project.account.name) + "\n                  " + _vm._s(project.account.country.prefix) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Campaña")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.aux_task.campaign_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('campaign_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Seleccione la campaña")]), _vm._v(" "), _vm._l((_vm.filteredCampaigns), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v("\n                  " + _vm._s(campaign.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Equipo")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.task.team_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('team_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el equipo")]), _vm._v(" "), _vm._l((_vm.teams), function(team) {
    return _c('option', {
      domProps: {
        "value": team.id
      }
    }, [_vm._v("\n                  " + _vm._s(team.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', {
    attrs: {
      "for": "msg"
    }
  }, [_vm._v("Estado")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.task.state_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('state_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el estado")]), _vm._v(" "), _vm._l((_vm.states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                  " + _vm._s(state.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-4 sm:col-span-4 xxl:col-span-6"
  }, [_c('label', [_vm._v("Usuario")]), _vm._v(" "), _c('select', {
    staticClass: "input w-full border mt-2 flex-1",
    attrs: {
      "required": ""
    },
    domProps: {
      "value": _vm.task.user_id
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('user_id', $event)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Seleccione el usuario")]), _vm._v(" "), _vm._l((_vm.filteredUsers), function(user) {
    return _c('option', {
      domProps: {
        "value": user.id
      }
    }, [_vm._v("\n                  " + _vm._s(user.name) + "\n                ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "my-3 col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('input', {
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.task.path
    },
    on: {
      "input": function($event) {
        return _vm.updateValue('path', $event)
      }
    }
  })]), _vm._v(" "), ([4, 5, 7].includes(_vm.task.state_id)) ? _c('div', {
    staticClass: "col-span-12 gap-4 grid grid-cols-12 py-5 row-gap-3 sm:col-span-12"
  }, [_c('div', {
    staticClass: "col-span-6 sm:col-span-6"
  }, [_c('label', [_vm._v("Descripcion Respuesta")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.response_observations),
      expression: "task.response_observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "1",
      "required": ""
    },
    domProps: {
      "value": (_vm.task.response_observations)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "response_observations", $event.target.value)
      }, function($event) {
        return _vm.updateValue('response_observations', $event)
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 sm:col-span-12"
  }, [_c('label', [_vm._v("Url Archivo Respuesta (opcional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.task.response_path),
      expression: "task.response_path"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.task.response_path)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.task, "response_path", $event.target.value)
      }, function($event) {
        return _vm.updateValue('response_path', $event)
      }]
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('button', {
    staticClass: "button w-24 bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit",
      "disabled": _vm.buttonIsLoading
    }
  }, [(_vm.buttonIsLoading) ? [_vm._v(" Cargando... ")] : [_vm._v(" Modificar ")]], 2)])]), _vm._v(" "), (_vm.task.versions.length) ? _c('div', [_c('div', {
    staticClass: "flex flex-col sm:flex-row items-center p-5 border-b border-gray-200"
  }, [_c('h2', {
    staticClass: "font-medium text-base mr-auto"
  }, [_vm._v("Versiones")])]), _vm._v(" "), _vm._l((_vm.task.versions), function(version) {
    return _c('div', {
      staticClass: "grid grid-cols-12 items-center p-5 border-b border-gray-200"
    }, [_c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_vm._v("\n                " + _vm._s(version.observations) + "\n                "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                  " + _vm._s(version.created_at) + "\n                ")]), _vm._v(" "), (version.path) ? _c('a', {
      attrs: {
        "href": version.path,
        "target": "_blank"
      }
    }, [_vm._v("Abrir Url")]) : _vm._e()]), _vm._v(" "), (version.response_observations) ? _c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_vm._v("\n                " + _vm._s(version.response_observations) + "\n                "), _c('div', {
      staticClass: "text-gray-600 text-xs"
    }, [_vm._v("\n                  " + _vm._s(version.updated_at) + "\n                ")]), _vm._v(" "), (version.response_path) ? _c('a', {
      attrs: {
        "href": version.response_path,
        "target": "_blank"
      }
    }, [_vm._v("Abrir Url")]) : _vm._e()]) : _c('div', {
      staticClass: "col-span-6 mt-3 lg:mt-0"
    }, [_c('form', {
      staticClass: "intro-y gap-3",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.updateVersion(version)
        }
      }
    }, [_c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.version_current.response_observations),
        expression: "version_current.response_observations"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "rows": "1",
        "required": ""
      },
      domProps: {
        "value": (_vm.version_current.response_observations)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.version_current, "response_observations", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-span-6 sm:col-span-6"
    }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.version_current.response_path),
        expression: "version_current.response_path"
      }],
      staticClass: "input w-full border mt-2",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.version_current.response_path)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.version_current, "response_path", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "mt-3 col-span-12 sm:col-span-12"
    }, [_c('button', {
      staticClass: "button bg-theme-1 text-white",
      attrs: {
        "type": "submit",
        "id": "editversion"
      }
    }, [_vm._v("\n                      Responder\n                    ")])])])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "intro-y grid grid-cols-12 gap-3 p-5 form-task",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createVersion.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Descripcion")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.observations),
      expression: "version.observations"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "rows": "1",
      "required": ""
    },
    domProps: {
      "value": (_vm.version.observations)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "observations", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Url Archivo (opcional)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.path),
      expression: "version.path"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.version.path)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "path", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-span-3 sm:col-span-3"
  }, [_c('label', [_vm._v("Fecha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.version.date),
      expression: "version.date"
    }],
    staticClass: "input w-full border mt-2",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.version.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.version, "date", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mt-8 col-span-3 sm:col-span-3"
  }, [_c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "create"
    }
  }, [_vm._v("\n                Crear Nueva Version\n              ")])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30b7776a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/task/EditTask.vue
// module id = 430
// module chunks = 1